import type { ReplayConfiguration } from "@slot/client-engine";
import type { SpinSpeedMode } from "./SpinCoordinatorTypes";

/**
 * How the engine replays a round at each speed. Normal and turbo animate everything (turbo is
 * faster through the clock); super turbo skips the filler phases whose actions are skippable and
 * keeps the win, settlement and frame-prepare phases, sped through the clock like the rest.
 */
export function replayConfigurationForSpeed(mode: SpinSpeedMode): Partial<ReplayConfiguration> {
  switch (mode) {
    case "normal":
    case "turbo":
      return { shouldSkipAnimations: false, shouldFailOnUnknownTypes: true };
    case "super_turbo":
      return {
        // Still drives the spin-boundary settle-beat skip.
        shouldSkipAnimations: true,
        actionPhaseSkipPolicy: { pre_removal: true, removal: true, post_removal: true, other: true },
        shouldFailOnUnknownTypes: true,
      };
  }
}
